export const FIELD_TYPES = {
  START_DATE: 'startDate',
  END_DATE: 'endDate'
}
